"use client";

import { c as _c } from "react/compiler-runtime";
import { configureLogger } from "@navikt/next-logger";
import { publicEnv } from "@/env-variables/publicEnv";
import { ApmRouteTracker } from "./ApmRouteTracker";
configureLogger({
  basePath: publicEnv.NEXT_PUBLIC_BASE_PATH
});
interface Props {
  children: React.ReactNode;
}
export const Instrumentation = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ApmRouteTracker />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <>{t1}{children}</>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};